/** Hardcoded - available before the stores have been initialized
 *
 */
export const uiConstants = {
  SECONDARIES: 'secondaries',
  SEPARATOR: '+',
  REDIRECT_SEARCH: 'redirect-search',
  REDIRECT_PATHNAME: 'redirect-pathname',
  CAROUSEL_THUMBNAIL_DROPPABLE_PREFIX: 'carousel-thumbnail-droppable-'
}



// WEBPACK FOOTER //
// ./src/uiConstants.ts